import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import { AdminLogin, Login} from './components/pages/index';
import SystemRoute from './SystemRoute';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/styles/style.css';

const App = () => {
  return (
    <div className="App">
    <BrowserRouter>
      <Switch>
        <Route exact path = "/Login" component={Login} />
        <Route exact path="/" component={Login} />
        <SystemRoute />
      </Switch>
    </BrowserRouter>
  </div>
  ) 
}

export default App;